import { useMutation, useQuery } from "react-query";
import { createSponsor, getSponsorsList } from "./sponsors-admin-service";

export const useGetSponsorsList = (config?: any) => {
  return useQuery("sponsors/list", () => getSponsorsList(), { ...config });
};
export const useCreateSponsor = () => {
  return useMutation((data: any) => createSponsor(data));
};
